import { useState } from 'react';
import { Modal } from '../../../../common/components/modals';
import { useLiquidatedOvertimeHours } from '../../hooks/useLiquidatedOvertimeHours';
import { LiquidatedOvertimeHourModel } from '../../models/liquidateOvertimeHours';
import { RejectLiquidatedOvertimeHoursRequest } from '../../models/requests';
import { Alert } from 'react-bootstrap';
import { toast } from 'react-toastify';

export interface RejectOverTimesModalProps {
    isOpen: boolean;
    onClose: () => void;
    data: LiquidatedOvertimeHourModel[];
    reHidrate: () => Promise<void>;
}

export const RejectOverTimesModal = ({
    data,
    isOpen,
    onClose,
    reHidrate,
}: RejectOverTimesModalProps) => {
    const [errorMessage, setErrorMessage] = useState('');
    const [commetsValue, setCommentsValue] = useState('');

    const { rejectOvertimeHours, isLoading } = useLiquidatedOvertimeHours();

    const handlerSubmit = async () => {
        try {
            const request: RejectLiquidatedOvertimeHoursRequest = {
                comments: commetsValue,
                preliquidationHourSummaryIds: data.map(
                    (d) => d.preliquidationHourSummaryId
                ),
            };
            const response = await rejectOvertimeHours(request);

            if ([400, 500, 404].includes(response?.response?.status)) {
                toast.error(
                    response?.response?.data ??
                        'Ocurrió un error al rechazar las horas extras'
                );
                setErrorMessage(
                    response?.response?.data ??
                        'Ocurrió un error al rechazar las horas extras'
                );
            } else {
                toast.success('Se rechazaron las horas extras correctamente');
                setErrorMessage('');
                onClose();
                reHidrate();
            }
        } catch (error) {
            toast.error('Ocurrió un error al rechazar las horas extras');
            setErrorMessage('Ocurrió un error al rechazar las horas extras');
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            modalTitle='Rechazar horas extras seleccionadas'
            disableSubmit={data?.length == 0 || isLoading}
            onSubmit={handlerSubmit}
            onClose={onClose}
            widthCustom='500px'
        >
            <div className='my-3'>
                {!isLoading && errorMessage !== '' && (
                    <Alert variant='danger'>{errorMessage}</Alert>
                )}
                <label htmlFor={'comments'} className='form-label form-label '>
                    Comentarios
                </label>
                <textarea
                    className='form-control text-dark'
                    id='comments'
                    data-lt-tmp-id='lt-465430'
                    spellCheck={false}
                    onChange={(e) => setCommentsValue(e.target.value)}
                    data-gramm='false'
                ></textarea>
            </div>
        </Modal>
    );
};
